import { render } from "./StoreData.vue?vue&type=template&id=46cae334&scoped=true"
import script from "./StoreData.vue?vue&type=script&lang=js"
export * from "./StoreData.vue?vue&type=script&lang=js"

import "./StoreData.vue?vue&type=style&index=0&id=46cae334&scoped=true&lang=css"
import "./StoreData.vue?vue&type=style&index=1&id=46cae334&lang=less&scoped=true"
import "./StoreData.vue?vue&type=style&index=2&id=46cae334&lang=less&scoped=true"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cae334"]])

export default __exports__